<!-- 开放许可专区详情 -->
<template>
  <div class="container">
    <div class="banner"></div>
    <div class="main">
      <div class="content">
        <div class="Breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/development' }"
              >开放许可专区</el-breadcrumb-item
            >
            <el-breadcrumb-item>详情</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="carousel-container"></div>
        <div class="box">
          <div class="carousel-container">
            <!-- 大图 -->
            <div class="big-image">
              <button class="arrow left-arrow" @click="prevImage">&lt;</button>
              <img
                :src="images[currentIndex]"
                :width="291"
                :height="291"
                alt="大图"
              />

              <button class="arrow right-arrow" @click="nextImage">&gt;</button>
              <!-- 左下角显示序号 -->
              <div class="image-index">
                {{ currentIndex + 1 }}/{{ images.length }}
              </div>
            </div>
            <!-- 小图列表 -->
            <div class="thumbnail-list">
              <div
                v-for="(image, index) in visibleThumbnails"
                :key="index"
                class="thumbnail-item"
                :class="{ active: currentIndex === thumbnailStart + index }"
                @click="changeImage(thumbnailStart + index)"
              >
                <img :src="image" :width="64" :height="64" alt="缩略图" />
              </div>
            </div>
          </div>
          <div class="article">
            <h1>{{ patentData.title }}</h1>
            <div class="body">
              <ul>
                <li style="width: 30%">
                  <span>产品分类: </span>
                  <p>{{ patentData.industrial_classification_text }}</p>
                </li>
                <li style="flex-direction: column; width: 70%">
                  <span>许可支付类型:</span>
                  <p style="color: rgba(234, 42, 53, 1)">
                    {{ patentData.license_payment_type_text }}
                  </p>
                </li>
              </ul>
              <ul>
                <li style="width: 30%">
                  <span>专利申请号: </span>
                  <p>{{ patentData.application_number }}</p>
                </li>
                <li style="width: 70%">
                  <span>申请日: </span>
                  <p>{{ formatDate(patentData.create_time) }}</p>
                </li>
              </ul>
              <ul>
                <li style="width: 30%">
                  <span>授权公告日: </span>
                  <p>{{ patentData.publication_date }}</p>
                </li>
                <li style="width: 70%">
                  <span>专利权人: </span>
                  <p>{{ patentData.patentee }}</p>
                </li>
              </ul>
              <ul>
                <li style="width: 30%">
                  <span>专利类型: </span>
                  <p>{{ patentData.patent_type_text }}</p>
                </li>
                <li style="width: 70%">
                  <span>权利状态: </span>
                  <p>{{ patentData.authorization_type_text }}</p>
                </li>
              </ul>
              <ul>
                <li style="width: 30%">
                  <span>发明人: </span>
                  <p>{{ patentData.inventor }}</p>
                </li>
              </ul>
            </div>
            <div class="permission">
              <li>
                <span>许可人</span>
                <p>{{ patentData.user?.company }}</p>
              </li>
              <li>
                <span>许可人类型</span>
                <p>{{ patentData.user?.company }}</p>
              </li>
              <li>
                <span>平台联系人</span>
                <p>{{ contact }}</p>
              </li>
              <li>
                <span>联系电话</span>
                <p>{{ contact_tel }}</p>
              </li>
            </div>
          </div>
        </div>
        <div class="box_two">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="开发许可信息" name="first">
              <li>
                <span>单次许可期限</span>
                <p>{{ patentData.license_term }}</p>
              </li>
              <li>
                <span>许可⽀付类型</span>
                <p>
                  {{ patentData.license_payment_type_text }}
                </p>
              </li>
              <li>
                <span>许可费用</span>
                <p>{{ patentData.license_fee }}</p>
              </li>
              <li>
                <span>许可地域范围</span>
                <p>{{ patentData.area }}</p>
              </li>
              <li>
                <span>开放许可（试点）声明</span>
                <div class="left">
                  <!-- <a
                    v-for="(attachment, index) in attachments"
                    :key="index"
                    :href="attachment"
                    target="_blank"
                  >
                    附件{{ index + 1 }}
                  </a> -->
                  <a
                    :href="patentData.attachments"
                    download
                    @click.prevent="downloadFile(patentData.attachments)"
                  >
                    点击下载附件
                  </a>
                </div>
              </li>
            </el-tab-pane>
            <el-tab-pane label="专利信息" name="second"></el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPatentDetail, getWebsite } from "../api/userApi";
export default {
  name: "ProductCarousel",
  data() {
    return {
      patentData: {},
      // 图片数组，可以替换成你的实际图片地址
      images: [],
      currentIndex: 0,
      thumbnailStart: 0, // 当前显示的小图起始索引
      visibleCount: 4,
      intervalId: null,
      activeName: "first",
      contact: "",
      contact_tel: "",
    };
  },
  created() {
    this.fetchPatentDetail();
    this.fetchGetWebsite();
  },
  computed: {
    visibleThumbnails() {
      return this.images.slice(
        this.thumbnailStart,
        this.thumbnailStart + this.visibleCount
      );
    },
  },
  watch: {
    currentIndex(newVal) {
      // 当大图切换时，调整小图显示范围
      if (newVal < this.thumbnailStart) {
        this.thumbnailStart = newVal;
      } else if (newVal >= this.thumbnailStart + this.visibleCount) {
        this.thumbnailStart = newVal - this.visibleCount + 1;
      }
    },
  },
  methods: {
    async fetchGetWebsite() {
      const res = await getWebsite();

      if (res.code === 1) {
        this.contact = res.data.contact;
        this.contact_tel = res.data.contact_tel;
      }
    },
    downloadFile(url) {
      const link = document.createElement("a");
      link.href = url;
      link.download = url.split("/").pop(); // 使用文件名作为下载名称
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    formatDate(timestamp) {
      if (!timestamp) return "";

      // 假设时间戳是秒级（如需要毫秒级则去掉*1000）
      const date = new Date(timestamp * 1000);

      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },
    fetchPatentDetail() {
      console.log(this.$route.query.id, "id");

      getPatentDetail({ id: this.$route.query.id }).then((response) => {
        this.patentData = response.data;
        console.log("接口返回的数据是：", this.patentData);
        // 确保 carousel_images 是数组
        if (typeof response.data.carousel_images === "string") {
          // 如果是字符串，尝试按逗号分割（如果多个URL用逗号分隔）
          this.images = response.data.carousel_images
            .split(",")
            .map((url) => url.trim());
        } else if (Array.isArray(response.data.carousel_images)) {
          // 如果已经是数组，直接使用
          this.images = response.data.carousel_images;
        } else {
          // 如果既不是字符串也不是数组，可能是单个URL，包装成数组
          this.images = [response.data.carousel_images].filter(Boolean);
        }
        console.log("接口返回的图片是：", this.images);
        // 设置附件数据
        if (this.patentData.attachments) {
          // 假设attachments是一个数组，如果不是需要根据实际情况处理
          this.attachments = Array.isArray(this.patentData.attachments)
            ? this.patentData.attachments
            : [this.patentData.attachments];
        }
      });
    },
    changeImage(index) {
      this.currentIndex = index;
    },
    prevImage() {
      this.currentIndex =
        (this.currentIndex - 1 + this.images.length) % this.images.length;
    },
    nextImage() {
      this.currentIndex = (this.currentIndex + 1) % this.images.length;
    },
    handleClick(tab, event) {
      console.log(tab, event);
      if (tab.name === "second") {
        this.$router.push(`/patent?id=${this.$route.query.id}`); // 跳转到专利信息页面
      }
    },
  },
};
</script>

<style scoped lang="less">
li {
  list-style: none;
}
.content {
  width: 100%;
  max-width: 87.5rem;
  margin: 0 auto;
}
.banner {
  background: url(../assets/banner2.png) no-repeat center/cover;
  width: 100%;
  height: 318px;
}
.main {
  background: #f5f5f5;
  padding-bottom: 45px;
  .Breadcrumb {
    padding: 15px 0;
    ::v-deep .el-breadcrumb__inner {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 14px;
      color: #121212;
    }
  }
  .box {
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    padding: 30px;
    display: flex;
    .carousel-container {
      width: 291px;
      margin-right: 35px;
    }

    .big-image img {
      width: 291px;
      height: 291px;
      object-fit: cover;
      border-radius: 8px;
    }
    .big-image {
      position: relative;
      .arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 22px;
        height: 42px;
        background: rgba(0, 0, 0, 0.33);
        // border-radius: 0px 6px 6px 0px;
        // opacity: 0.33;
        outline: none;
        border: none;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        z-index: 10;
        &.left-arrow {
          left: 0px; // 调整到适合的位置
          border-radius: 0px 6px 6px 0px;
        }
        &.right-arrow {
          right: 0px; // 调整到适合的位置
          border-radius: 6px 0px 0px 6px;
        }
      }

      .image-index {
        position: absolute;
        bottom: 15px;
        left: 15px;
        width: 50px;
        height: 23px;
        background: #000000;
        border-radius: 8px;
        opacity: 0.33;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
      }
    }
    .thumbnail-list {
      display: flex;
      justify-content: flex-start;
      margin-top: 10px;
      overflow: hidden;
    }

    .thumbnail-item {
      cursor: pointer;
      border: 2px solid transparent;
      transition: border-color 0.3s ease;
      margin-right: 6px;
    }

    .thumbnail-item img {
      width: 64px;
      height: 64px;
      object-fit: cover;
      border-radius: 4px;
    }
    .article {
      width: 100%;
      h1 {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 22px;
        color: #0c1223;
        text-align: left;
        border-bottom: 1px solid #f5f5f5;
        padding-bottom: 15px;
        width: 100%;
      }
      .body {
        display: flex;
        flex-direction: column;
        ul {
          display: flex;
          width: 100%;
          margin-top: 15px;
          li {
            display: flex;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 14px;

            text-align: left;
            span {
              color: rgba(12, 18, 35, 0.5);
            }
            p {
              color: rgba(12, 18, 35, 1);
            }
          }
        }
      }
      .permission {
        display: flex;
        width: 588px;
        height: 84px;
        background: #fafafa;
        border-radius: 6px 6px 6px 6px;
        // padding: 25px 0;
        align-items: center;
        margin-top: 15px;
        li {
          flex: 1;
          display: flex;
          flex-direction: column;
          border-right: 1px solid #dddddd;
          span {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #1c1d25;
            text-align: center;
            margin-bottom: 10px;
          }
          p {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 12px;
            color: #606060;
            line-height: 17px;
            text-align: center;
          }
        }
        li:last-child {
          border-right: 0;
        }
      }
    }
  }
  .box_two {
    margin-top: 20px;
    background: #ffffff;
    border-radius: 10px 10px 10px 10px;
    ::v-deep .el-tabs__nav-wrap {
      padding-left: 30px;
    }
    ::v-deep .el-tabs__active-bar {
      height: 3px;
      background-color: rgba(23, 93, 194, 1);
    }
    :v-deep .el-tabs__item {
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 16px;
      color: rgba(28, 29, 37, 1);
    }
    ::v-deep .el-tabs__item.is-active {
      color: rgba(23, 93, 194, 1) !important;
    }
    ::v-deep .el-tab-pane {
      padding: 0 30px;
    }
    ::v-deep .el-tabs__header {
      margin: 0;
    }
    li {
      display: flex;
      flex-direction: column;
      border-bottom: 1px solid rgba(239, 237, 237, 1);
      padding-bottom: 30px;
      margin-top: 30px;
      span {
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 16px;
        color: #121212;
        text-align: left;
        margin-bottom: 10px;
      }
      p {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #121212;
        text-align: left;
      }
      a {
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 14px;
        color: #175dc2;
        text-align: left;
        margin-right: 15px;
      }
      .left {
        display: flex;
        justify-content: flex-start;
      }
    }
  }
}
</style>
